<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'saleModule.sale' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <sale-table
    [showOrganization]="false"
    [showTotal]="true"
    [tableData$]="sales$"
    (onClickRow)="onRowClicked($event)"
    [saleTableOptions]="{ hideMember: false, hideCheckbox: true }"
  ></sale-table>
  <!-- End Body -->
</section>
<!-- End Card -->
